/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
// nothing yet

/**
 *     @section 2. Class
 */
class Popup {
    public render(data: any):string {
        // Translation: https://drupal.stackexchange.com/questions/35527/drupal-t-does-not-work
        var popupContent = `
            <div class="map-popup">
                <div class="map-popup__header">
                    <h3 class="h4 map-popup__headline headline-with-background">
                        <span>${data.region}</span>
                    </h3>
                    <div class="map-popup__image">
                        ${data.image}
                    </div>
                </div>
                <div class="map-popup__content">
                    <h4 class="h5">${data.title}</h4>
                    <a
                        class="button button--primary button--round ${data.type}"
                        href="${data.link.href}#partner-${data.link.nid}"
                        hreflang="${data.link.hreflang}"
                        target="_blank"
                    >
                        ${Drupal.t('Show')}
                    </a>
                </div>
            </div>
        ` // Popup content

        return popupContent
    }
}

/**
 *     @section 3. Export class
 */

export default new Popup()

// end of popup.ts file
